import { injectable, inject } from 'inversify';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { CompleteInteractionCommand, CompleteInteractionCommandPayload } from '../api';
import { Scorm2004InteractionDataStore } from '@/app/tracking/scorm/2004/store';
//import { InteractionSuspendDataStore } from '../common';

// temporary disabled interaction sending to workaround Moodle BUG MDL-68896
const ENABLE_SCORM_INTERACTIONS = false

@injectable()
export class Scorm2004CompleteInteractionCommandHandler implements CommandHandler<CompleteInteractionCommand> {

  constructor(
    @inject(Scorm2004InteractionDataStore)
    private scormInteractionStore: Scorm2004InteractionDataStore,
    // @inject(InteractionSuspendDataStore)
    // private suspendDataStore: InteractionSuspendDataStore,
) {
  }

  public async execute(command: CompleteInteractionCommandPayload) {

    // store in suspend data and scorm interaction store too
//    await this.suspendDataStore.execute(createCommand<CompleteInteractionCommand>('complete-interaction', command))

    if (ENABLE_SCORM_INTERACTIONS) {
      await this.scormInteractionStore.update({
        ...command.interaction,
        type: command.meta.type,
        description: command.meta.title
      });
    }
  }
}
